import React from "react"
import { useCMSReady } from "../../../../domain/CMS/useCMSReady"
import { populateCmsTemplate } from "../../utils"
import { Label } from "../Label"
import Spinner from "../Spinner"
import { Typography, typographyTypes } from "../Typography"
import Icon from "../Icon"

interface FileUploadChildProps {
  name: string
  onRemoveClick: () => void
  error?: string
  isLoading?: boolean
  isRequired?: boolean
  label?: string
  removeButtonRef?: React.RefObject<HTMLButtonElement>
}

export const FileUploadChild: React.FC<FileUploadChildProps> = ({
  name,
  onRemoveClick,
  error,
  isLoading,
  isRequired = false,
  label,
  removeButtonRef,
}) => {
  const { cms: cmsContent } = useCMSReady(["common"])
  const common = cmsContent.common

  return (
    <div className="flex flex-col space-y-2 w-full">
      {!!label && (
        <Label
          text={label}
          htmlFor={`file-upload-${name}`}
          isRequired={isRequired}
          size="sm"
          fontWeight="medium"
        />
      )}
      <div className="flex flex-row justify-space-between border border-solid border-gray-300 rounded-lg px-5 py-[23px]">
        <div
          className="flex flex-row w-full items-center"
          id={`file-upload-${name}`}
        >
          {isLoading && (
            <Spinner
              containerStyleOverrides="h-9 w-9"
              parentStyleOverrides="h-fit w-fit"
              text=""
            />
          )}
          {!isLoading && <Icon iconType="file" />}
          <div className="flex flex-col space-y-1 pl-3 pr-5">
            <Typography
              text={name}
              variant={typographyTypes.LABEL}
              styleOverrides="break-all"
            />
            {isLoading && (
              <Typography
                text={common?.uploading ?? ""}
                variant={typographyTypes.ERROR}
                styleOverrides="text-primary-blue"
              />
            )}
            {!isLoading && error && (
              <Typography text={error} variant={typographyTypes.ERROR} />
            )}
            <div aria-live="polite" aria-atomic="true" className="sr-only">
              {!isLoading && error ? error : ""}
            </div>
          </div>
        </div>
        {!isLoading && (
          <button
            aria-label={populateCmsTemplate(
              [name],
              "cms.common.removeFile",
              common?.uploadRemoveSelectedFileAriaLabel,
            )}
            onClick={() => onRemoveClick()}
            className="flex items-center justify-center bg-transparent border-0 hover:cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-blue rounded-sm"
            aria-labelledby={populateCmsTemplate(
              [name],
              "cms.common.removeFile",
              common?.uploadRemoveSelectedFileAriaLabel,
            )}
            ref={removeButtonRef}
          >
            <Icon iconType="x" />
          </button>
        )}
      </div>
    </div>
  )
}
